import type { FC } from 'react';
import { useCallback } from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import type { SelectChangeEvent } from '@mui/material';
import type { PostType } from '../types';

const POST_TYPE_OPTIONS: { value: PostType; label: string }[] = [
  { value: 'all', label: 'All' },
  { value: 'text', label: 'Text' },
  { value: 'visual', label: 'Visual' },
];

interface TrendsPostTypeFilterProps {
  value: PostType;
  onChange: (value: PostType) => void;
}

const TrendsPostTypeFilter: FC<TrendsPostTypeFilterProps> = ({ value, onChange }) => {
  const handleChange = useCallback(
    (event: SelectChangeEvent) => {
      onChange(event.target.value as PostType);
    },
    [onChange]
  );

  return (
    <FormControl size="small" sx={{ minWidth: 130 }}>
      <InputLabel id="trends-post-type-label">Post type</InputLabel>
      <Select
        labelId="trends-post-type-label"
        id="trends-post-type"
        label="Post type"
        value={value}
        onChange={handleChange}
      >
        {POST_TYPE_OPTIONS.map(({ value: optionValue, label }) => (
          <MenuItem key={optionValue} value={optionValue}>
            {label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default TrendsPostTypeFilter;
